module.exports = __webpack_public_path__ + "img/face_shapes.0af4491e.jpg";